import React, { useRef, useState } from 'react'
import { Typography, Grid, Card } from "@mui/material";
import InputFieldComponent from '../common/InputFieldComponent';
import ButtonComponent from '../common/ButtonComponent';
import { serviceProvider } from '../../provider/serviceProvider';
import { toast } from "react-toastify";
import dayjs, { Dayjs } from 'dayjs';
import DateTimePickerComponent from '../common/DateTimePickerComponent';
import { IValidationResponse } from '../../interface/IValidation';
import { ValidationType } from '../../enum/validationType';
import { ValidationUtiltiy } from '../../utility/ValidationUtility';
import Loader from '../loader/Loader';
import addImageIcon from "../../assets/icons/add-image.svg";
import S3 from "react-aws-s3-typescript";
import { awsConfig } from "../../configuration/config.json";

// title, date to deactivate, redirect link, image  


const initalUserInput = {
    active: true,
    datetimeToDeactivate:"",
    feedDescription: "",
    feedId: 0,
    feedTitle: "",
    redirect_link: {
      cta_link:"",
      cta_name:"Know More",
    },
    imageUrl: {
      mobile: "",
      desktop: "",
     },
}

const AddFeedForm = ({ handleCloseModal ,getAllFeeds}: any) => {
    const [userInput, setUserInput] = useState(initalUserInput);
    const [loader, setLoader] = useState(false);
    const [imgLoader,setImgLoader]=useState(false)
    const [deactivateDateTime, setDeactivateDateTime] = useState(null);
    const [file, setFile] = useState<any>(null);
    const [activeImage, setActiveImage] = useState<"mobile" | "desktop" | null>(null);

    const chooseFileRef: React.MutableRefObject<HTMLInputElement | null> = useRef(null);


const handleChooseFile = (type: "mobile" | "desktop") => {
  setActiveImage(type);
  chooseFileRef.current?.click();
};


    
const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = event.target;

  if (name === "cta_link" || name === "cta_name") {
    setUserInput((prev) => ({
      ...prev,
      redirect_link: {
        ...prev.redirect_link,
        [name]: value,
      },
    }));
  } else {
    setUserInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  validateFieldsOnInput(name);
};




const validateFieldsOnInput = (key: string) => {
  switch (key) {
    case "feedTitle":
      validateFeedTitle();
      break;

    case "cta_link":
      validateRedirectLink();
      break;

    case "cta_name":
      validateCTAName();
      break;

    default:
      break;
  }
};

    const handleDeactivateDateTime = (newDate: any) => {
        setDeactivateDateTime(newDate);
    }
   

    const handleFileChange = (event: any) => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
          return;
        }
        const isValid = ValidationUtiltiy.isValidImg(fileObj.name);
        if (isValid) {
          setFile(fileObj);
          let newFileName =
            // userDetails?.uid +
            "123" +
            "_" +
            event.target.files[0].name.replace(/\..+$/, "");
          uploadImage(fileObj, newFileName);
        } else {
          toast.error("Not a valid File");
          // handleCloseM()
        }
    
    
    
      };
    
    
      const uploadImage = (file: any, newFile: any) => {
        setImgLoader(true)
        // handleCloseM()
        const ReactS3Client = new S3(awsConfig);
        ReactS3Client.uploadFile(
          file,
          awsConfig.feedsSubFolder + "/" + newFile
        ).then((data) => {
          // console.log("upload cover image", data);
          if (data.status === 204) {
  updateUserInput(data.location, activeImage);
  toast.success(`${activeImage?.toUpperCase()} image uploaded successfully!`);
}
 else {
            // setLoader(false)
            console.log("File Not Uploaded !!");
            toast.error("Error Occured");
          }
          setImgLoader(false)
        }).catch((err) => {
          setImgLoader(false)
          console.log({ err })
          toast.error("Something Went Wrong.")
        })
      };
    
    
const updateUserInput = (imageUrl: string, type: "mobile" | "desktop" | null) => {
  if (!type) return;
  setUserInput(prev => ({
    ...prev,
    imageUrl: {
      ...prev.imageUrl,
      [type]: imageUrl,
    },
  }));
};


    const handleAddFeed = () => {
        const formattedDeactivateDateTime = deactivateDateTime
          ? dayjs(deactivateDateTime).utc().format("YYYY-MM-DDTHH:mm:ss")
          : "";

       
        const payload = {
  ...userInput,
  datetimeToDeactivate: formattedDeactivateDateTime,
  imageUrl: JSON.stringify(userInput.imageUrl), 
  redirect_link: JSON.stringify(userInput.redirect_link), 
};

        isValidRequest().then(() => {
            setLoader(true)
            serviceProvider.feedService.post(payload).then((res) => {
                if (res.responseCode === 200) {

                    toast.success(res.message)
                    handleCloseModal();
                    const query = `search?feedTitle=all&feedId=all&isActive=true&offset=0&limit=10&order=updatedTs.desc&profile=BASIC`
                    getAllFeeds(query)
                } else {
                    toast.error(res?.message||"Something Went Wrong !!")
                }
                setLoader(false)

            }).catch((err) => {
                toast.error(err?.data?.message || "Something Went Wrong!!")
                console.log({ err })
                setLoader(false)
            })
        }).catch(() => {
            toast.error('Please fill all the Required Fields!');
        })
    }


    return (
        <Grid container spacing={3} className='add-fleet-container'>
            <Grid item xs={12} className="modal-table-container">
                <Grid container className='heading'>
                    <Grid item xs={12}>
                        <Typography variant='h6' component='h6'>Add Feed</Typography>
                    </Grid>
                </Grid>
                <Grid container className="edit-detail-item">
                    <Grid item xs={6} className='edit-item dark-bg'>
                        <Typography variant='body1' component='p'>
                            Title
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className='edit-item'>
                        <Grid item xs={12} >
                            <InputFieldComponent
                                id="feed-title"
                                type="text"
                                name="feedTitle"
                                value={userInput.feedTitle}
                                onChange={handleInputChange}
                            />
                            <span className="modalError" id='errorDiv-feed-title'></span>
                        </Grid>


                    </Grid>
                </Grid>
                
                <Grid container className="edit-detail-item">
                    <Grid item xs={6} className='edit-item dark-bg'>
                        <Typography variant='body1' component='p'>
                            Redirect Url
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className='edit-item'>
                        <Grid item xs={12} >
                            <InputFieldComponent
                                 id="cta-link"
      type="url"
      name="cta_link"
      value={userInput.redirect_link.cta_link}
      onChange={handleInputChange}
                            />
                            <span className="modalError" id="errorDiv-cta-link"></span>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid container className="edit-detail-item">
                    <Grid item xs={6} className='edit-item dark-bg'>
                        <Typography variant='body1' component='p'>
                           CTA Label
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className='edit-item'>
                        <Grid item xs={12} >
                            <InputFieldComponent
                                id="cta-name"
      type="text"
      name="cta_name"
      value={userInput.redirect_link.cta_name}
      onChange={handleInputChange}
                            />
                            <span className="modalError" id="errorDiv-cta-name"></span>
                        </Grid>

                    </Grid>
                </Grid>
               
                <Grid container className="edit-detail-item">
                    <Grid item xs={6} className='edit-item dark-bg'>
                        <Typography variant='body1' component='p'>
                            Deactivate Date Time
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className='edit-item'>
                        <DateTimePickerComponent
                            placeholder="Deactivate Date Time"
                            value={deactivateDateTime}
                            disablePast={true}
                            onChange={handleDeactivateDateTime}
                        />

                    </Grid>
                </Grid>
               

            </Grid>
            <Grid item xs={12} container spacing={2}>
  {/* 📱 Mobile Banner Image Upload */}
  <Grid item xs={12} md={6}>
    <Typography
      variant="subtitle1"
      sx={{ fontWeight: 600, mb: 1, textAlign: { xs: "center", md: "left" } }}
    >
      Mobile Banner Image
    </Typography>

    {imgLoader && activeImage === "mobile" ? (
      <Loader height="230px" width="100%" />
    ) : (
      <Card className="feed-image-card">
        <img
          src={userInput.imageUrl.mobile || addImageIcon}
          className={`${userInput.imageUrl.mobile ? "card-img" : "add-img"}`}
          alt="mobile"
          onClick={() => handleChooseFile("mobile")}
        />
      </Card>
    )}
  </Grid>

  {/* 💻 Desktop Banner Image Upload */}
  <Grid item xs={12} md={6}>
    <Typography
      variant="subtitle1"
      sx={{ fontWeight: 600, mb: 1, textAlign: { xs: "center", md: "left" } }}
    >
      Desktop Banner Image
    </Typography>

    {imgLoader && activeImage === "desktop" ? (
      <Loader height="230px" width="100%" />
    ) : (
      <Card className="feed-image-card">
        <img
          src={userInput.imageUrl.desktop || addImageIcon}
          className={`${userInput.imageUrl.desktop ? "card-img" : "add-img"}`}
          alt="desktop"
          onClick={() => handleChooseFile("desktop")}
        />
      </Card>
    )}
  </Grid>

  {/* Hidden File Input */}
  <input
    style={{ display: "none" }}
    ref={chooseFileRef}
    type="file"
    onChange={handleFileChange}
  />
</Grid>

            <Grid item xs={12} >
                <Grid container columnSpacing={2} display="flex" justifyContent="center" alignItems="center" mt="20px">
                    <Grid item xs={2}>
                        <ButtonComponent loader={loader} disabled={loader} label="Save" onClick={handleAddFeed} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default AddFeedForm;




const isValidRequest = (): Promise<boolean> => {
  const responseArray: IValidationResponse[] = [];
  responseArray.push(validateFeedTitle());
  responseArray.push(validateRedirectLink());
  responseArray.push(validateCTAName());

  const haveErrors = responseArray.filter((x) => !x.isValid).length <= 0;
  return new Promise((resolve, reject) => {
    haveErrors ? resolve(true) : reject(false);
  });
};

const validateFeedTitle = () => {
    return ValidationUtiltiy.validateElement("feed-title", ValidationType.Text, true, "errorDiv-feed-title", "Title");
}
const validateRedirectLink = () => {
  return ValidationUtiltiy.validateElement(
    "cta-link",
    ValidationType.URL,
    true,
    "errorDiv-cta-link",
    "Redirect URL"
  );
};

const validateCTAName = () => {
  return ValidationUtiltiy.validateElement(
    "cta-name",
    ValidationType.Text,
    true,
    "errorDiv-cta-name",
    "CTA Label"
  );
};



